import { isActivePrivilegeRead } from "../utils/AuthHelper";

function Sidebar() {

  return (
    <div className="sidebar-wrapper" data-simplebar="true">
      <div className="sidebar-header">
        <div className="">
          <img
            src="../assets/images/icon-ravelware.png"
            className="logo-icon-2"
            alt=""
          />
        </div>
        <div>
          <h4 className="logo-text">WMS-RFID</h4>
        </div>
        <a href="#section" className="toggle-btn ms-auto">
          <i className="bx bx-menu"></i>
        </a>
      </div>
      <ul className="metismenu" id="menu">
        <li>
          <a href="/admin/dashboard">
            <div className="parent-icon icon-color-1">
              <i className="bx bx-home-alt"></i>
            </div>
            <div className="menu-title">Dashboard</div>
          </a>
        </li>
        {isActivePrivilegeRead("Warehouse Visualization") ? <li>
          <a href="/admin/visualization">
            <div className="parent-icon icon-color-2">
              <i className="bx bx-image-alt"></i>
            </div>
            <div className="menu-title">Visualization</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Analytic Report") ? <li>
          <a href="/admin/analytic-report">
            <div className="parent-icon icon-color-3">
              <i className="bx bx-chart"></i>
            </div>
            <div className="menu-title">Analytic Report</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Notification Gate") ? <li>
          <a href="/admin/notification-gate">
            <div className="parent-icon icon-color-4">
              <i className="bx bx-bell"></i>
            </div>
            <div className="menu-title">Notification Gate</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Inbound") ? <li>
          <a href="/admin/inbound">
            <div className="parent-icon icon-color-4">
              <i className="bx bx-archive-in"></i>
            </div>
            <div className="menu-title">Inbound</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Request Part") ? <li>
          <a href="/admin/request-part">
            <div className="parent-icon icon-color-5">
              <i className="bx bx-calendar-check"></i>
            </div>
            <div className="menu-title">Request Part</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Outbound") ? <li>
          <a href="/admin/outbound">
            <div className="parent-icon icon-color-7">
              <i className="bx bx-archive-out"></i>
            </div>
            <div className="menu-title">Outbound</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Stock Opname") ? <li>
          <a href="/admin/stock-opname">
            <div className="parent-icon icon-color-8">
              <i className="bx bx-box"></i>
            </div>
            <div className="menu-title">Stock Opname</div>
          </a>
        </li> : null}
        {isActivePrivilegeRead("Master Data") ? <li>
          <a className="has-arrow" href="#section">
            <div className="parent-icon icon-color-8">
              <i className="bx bx-data"></i>
            </div>
            <div className="menu-title">Master Data</div>
          </a>
          <ul>
            <li>
              <a href="/admin/warehouse">
                <i className="bx bx-right-arrow-alt"></i>Warehouse
              </a>
            </li>
            <li>
              <a href="/admin/rack">
                <i className="bx bx-right-arrow-alt"></i>Rack
              </a>
            </li>
            <li>
              <a href="/admin/part">
                <i className="bx bx-right-arrow-alt"></i>Part
              </a>
            </li>
            <li>
              <a href="/admin/rfid">
                <i className="bx bx-right-arrow-alt"></i>RFID
              </a>
            </li>
            <li>
              <a href="/admin/privilege">
                <i className="bx bx-right-arrow-alt"></i>Privilege
              </a>
            </li>
            <li>
              <a href="/admin/departement">
                <i className="bx bx-right-arrow-alt"></i>Departement
              </a>
            </li>
            <li>
              <a href="/admin/user">
                <i className="bx bx-right-arrow-alt"></i>User
              </a>
            </li>
          </ul>
        </li> : null}
        {isActivePrivilegeRead("Setting") ? <li>
          <a className="has-arrow" href="#section">
            <div className="parent-icon icon-color-9">
              <i className="bx bx-wrench"></i>
            </div>
            <div className="menu-title">Setting</div>
          </a>
          <ul>
            <li>
              <a href="/admin/access-control-list">
                <i className="bx bx-right-arrow-alt"></i>Access Control List
              </a>
            </li>
          </ul>
        </li> : null}
        <a href="" onClick={() => {
          if (window.confirm('Are you sure you want to open the manual book?')) {
            window.open('/User Manual WMS.pdf', '_blank');
          } else {
            return false;
          }
        }}
        >
          <div className="parent-icon icon-color-9">
            <i className="bx bx-file"></i>
          </div>
          <div className="menu-title">Manual Book</div>
        </a>
      </ul>
    </div>
  );
}


export default Sidebar;
